type TagId = string;
type State = Map<TagId, number>;

export const getCountByTagId = (
  state: State,
  tagId: TagId
): number | null | undefined => {
  return state.get(tagId);
};

export const tagHasNoResults = (state: State, tagId: TagId): boolean => {
  return state.get(tagId) === undefined;
};
